export default "__VITE_ASSET__ChF31iAm__"